
import React,{Fragment}  from 'react';
import { Route,Routes ,useParams  } from 'react-router-dom';


import ReportsOfficiers from '../reports/reports_officier';
import ReportsMemberChange from '../reports/reports_memberchange';
import ReportsYear from '../reports/reports_member_year';
import ReportsRadier from '../reports/reports_radier';
import ReportsEffectif from '../reports/reports_effectif';
import ReportsEffectifDetailOneDate from '../reports/reports_effectif_complet_one_date';

import ReportsEffectifDetailOneDate_sensitive from '../reports/reports_effectif_complet_one_date_sensitive';
import ReportsFacturation from '../reports/rapportFacture';
import ReportsMembreSecteur from '../reports/reports_membres_secteurs';
import Report_all_club_datagrid from '../reports/report_all_club_datagrid';
import ReportsProchaineFacturation from '../reports/reports_prochaine_facturation';

import Home from '../home/home';
import HomePrivate from '../home/home_private';
import Clubs from '../clubs/clubs';
import Club from '../clubs/club';
import NouveauClub from '../clubs/nouveau_club';
import GenererFactureTrimestre from '../clubs/genererFactureTrimestre';
import ClubSecteur from '../clubs/clubssecteur';
import Member from '../members/member';
import Login from '../../components/auth/login';
import Utilisateurs from '../utilisateurs/utilisateurs';
import Coupons from '../coupons/coupons';


function MyRoutes() {
  return (
          
     
        <Fragment>        
          <Routes>
            <Route exact path='/' element={<Home/>} />
            <Route exact path='/home' element={<HomePrivate/>} />
            <Route path='/param/:token' element={<Home/>} />
            <Route path='/login' element={<Login/>} />

            

            <Route path='/report_all_club_datagrid' element={<Report_all_club_datagrid/>} />
            <Route path='/reports_effectif' element={<ReportsEffectif/>} /> 
            <Route path='/reports_effectif_one_date' element={<ReportsEffectifDetailOneDate/>} />  
            <Route path='/reports_memberchange' element={<ReportsMemberChange/>} />  
            <Route path='/reports_member_year/:myear/:myreport' element={<ReportsYear/>} />           
            <Route path='/reports_officier' element={<ReportsOfficiers/>} />
            <Route path='/reports_radier' element={<ReportsRadier/>} />
            <Route path='/reports_membre_secteur' element={<ReportsMembreSecteur/>} />
            
            

            <Route path='/clubs' element={<Clubs/>} /> 
            <Route path='/club'  element={<Club />} /> 
            <Route path='/clubssecteur' element={<ClubSecteur/>} />  

            <Route path='/nouveauclub'  element={<NouveauClub />} /> 
            <Route path='/genererFactureTrimestre'  element={<GenererFactureTrimestre />} /> 
            <Route path='/reportsFacturation'  element={<ReportsFacturation />} />
            <Route path='/reportsProchaineFacturation'  element={<ReportsProchaineFacturation />} /> 
            <Route path='/reports_effectif_one_date_sensitive' element={<ReportsEffectifDetailOneDate_sensitive/>} /> 
            <Route path='/member'  element={<Member />} />            
            <Route path='/utilisateurs'  element={<Utilisateurs />} />   
            <Route path='/coupons'  element={<Coupons />} />   

            
          </Routes>
         
        </Fragment>

  
   
  );
}



export default MyRoutes;
